import { Component } from "@angular/core";
import { DemoFormulaField } from "@demo/data/demo-formulas";
import { FormulaDefinitionComponent } from "@module-definition/formulas/cipo-formula-definition/cipo-formula-definition.component";
import { FormulaDefinitionService } from "../../../module/definition/formulas/cipo-formula-definition/cipo-formula-definition.service";
import { DemoFormulasService } from "./demo-formulas.service";

@Component({
  selector: 'app-demo-formulas',
  templateUrl: './demo-formulas.component.html',
  imports: [FormulaDefinitionComponent],
  providers: [{ provide: FormulaDefinitionService, useClass: DemoFormulasService }]
})
export class DemoFormulasComponent {
  fields = DemoFormulaField;
}